module.exports = __webpack_public_path__ + "static/media/failed.0ca9c8ef.mp3";